import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, JwTokenModel, UserModel,

ClientModel, SystemFeatureModel,

ClientSystemFeatureStatusViewModel,

ClientSystemSettingValueModel,
ClientSystemSettingViewModel,
ClientCompanyViewModel

 } from "../../core/api/models";
import { ClientsApiService } from '../../core/api/services';
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { catchError, map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { ClientService } from '../';
import { AlertService } from "../../shared/services/alert.service";
import { of } from "rxjs/internal/observable/of";
import { ClientSystemSettingEditModel } from "./ClientSystemSettingEditModel";
import {SystemSettingType} from "../../core/api/models/system-setting-type";


@Component({
  selector: 'app-client-features-component',
  templateUrl: './client-features.component.html',
  styleUrls: ['./client-features.component.css'],
  standalone: false
})
export class ClientFeaturesComponent implements OnInit, AfterViewInit {
  
  
  SystemSettingType: typeof SystemSettingType = SystemSettingType;
  currentClient?: ClientModel;
  featureStatuses?: ClientSystemFeatureStatusViewModel[];
  companies: ClientCompanyViewModel[] =[];



  currentFeatureStatus: ClientSystemFeatureStatusViewModel|null = null;
  settings?: ClientSystemSettingEditModel[];
  
  
  loading = true;
  saving = false;
  
  constructor(private authService: AuthService,
    private readonly clientService: ClientService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private readonly clientsApiService: ClientsApiService) {
  }


  ngOnInit(): void {
       
    
    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);


    
    
      this.clientService.getCurrentClient().subscribe((client) => {

      if (client){
         this.currentClient = client;      

          this.clientsApiService.GetClientSystemFeatureStatuses
           ({ clientID: this.currentClient?.ID||0, }).pipe(catchError(error => {
              this.alertService.error(Utils.getAjaxError(error));
              return of(undefined);
            })).subscribe((statuses) => {
              if (statuses) {
                this.featureStatuses = statuses;
              }else  {
                this.featureStatuses = [];
              }
              this.loading = false;
            });



        this.clientsApiService.GetClientCompanies({ clientID: this.currentClient?.ID||0, }).pipe(catchError(error => {
            this.alertService.error(Utils.getAjaxError(error));

            return of(undefined);

          })).subscribe((companies) => {
            if (companies)
              this.companies =  companies;
          });
      }
    });
  }

  ngAfterViewInit(): void {
    

    
    
  }
  

  selectFeature(feature?: ClientSystemFeatureStatusViewModel): void {
    //if (this.loading) return;
    this.currentFeatureStatus = feature || null;


    
    console.debug("selectFeature" +this.currentFeatureStatus);

   this.clientsApiService.GetClientSystemSettings({ clientID: this.currentClient?.ID||0,
     body: { systemFeatureID :this.currentFeatureStatus?.SystemFeatureID||0 }
  }).pipe(catchError(error => {
      this.alertService.error(Utils.getAjaxError(error));
      return of(undefined);
    })).subscribe((settings) => {

      this.settings = [];
      if (settings) {
        for (const setting of settings) {
          const editModel = new ClientSystemSettingEditModel(this.currentClient?.ID, this.clientsApiService, this.alertService, setting);
          this.settings.push(editModel);
        }
      } else {
        
      }
    });

  }


  saveFeatureStatus(value: boolean): void {
    if (!this.currentFeatureStatus) return;

    this.currentFeatureStatus.TurnedOn = value;
    this.saving = true;
    this.clientsApiService.SaveClientSystemFeatureStatus({
      clientID: this.currentClient?.ID || 0,body:{ ...this.currentFeatureStatus }
      
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        this.alertService.error(Utils.getAjaxError(error));
        return of(undefined);
      })
    ).subscribe((result) => {
      if (result) {
       // this.currentFeatureStatus = result;
      }
      this.saving = false;
    });
  }

  getCompanyName(companyID: number| null | undefined): string {

    if (!companyID) return 'Enterprise';

    return  this.companies?.find(value => value.ID === companyID)?.BusinessAbbreviation ?? 'Company #' + companyID;
  }
  


}

